/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';
import { ModelJobStates } from 'src/modules/modelTraining/types/trainingTypes';

type EvaluationJobStoreData = OmitFunctions<Partial<Omit<EvaluationJobStore, 'id'>>>;

export class EvaluationJobStore {
    public id: string;

    public modelId: string;

    public startDateTime: Date;

    @observable public errors: string[];

    @observable public endDateTime: Date;

    @observable public status: ModelJobStates;

    @observable public percentComplete: number;

    constructor(id: string, data?: EvaluationJobStoreData) {
        this.id = id;
        this.status = data?.status;
        this.modelId = data?.modelId;
        this.errors = data?.errors ?? [];
        this.percentComplete = data?.percentComplete ?? 0;
        this.endDateTime = data?.endDateTime ?? new Date();
        this.startDateTime = data?.startDateTime ?? new Date();
    }

    @action
    public updateData(data: EvaluationJobStoreData) {
        this.status = data.status;
        this.errors = data.errors;
        this.endDateTime = data.endDateTime;
        this.percentComplete = data.percentComplete;
    }

    @action
    public setEndDateTime(dateTime: Date) {
        this.endDateTime = dateTime;
    }

    @action
    public setStatus(status: ModelJobStates) {
        this.status = status;
    }

    @action
    public setPercentComplete(percentage: number) {
        this.percentComplete = percentage;
    }
}
